import { Flex, Icon, Typography } from '@aloft/toolkit-sui';

import { AlertsContent } from './AlertsContent.tsx';
import { useAlerts } from './hooks/useAlerts.tsx';

export const CraftsmanAlertsSheet = () => {
  const alerts = useAlerts();

  return (
    <Flex flexDirection="column" gap="1.5rem" paddingX="1rem" paddingBottom="1rem">
      <Flex gap="1rem" alignItems="center">
        <Icon icon="error-warning" color="statusWarning" size="lg" />
        <Typography variant="h1">Alerts</Typography>
      </Flex>
      <AlertsContent alerts={alerts} />
    </Flex>
  );
};
